import cc26SplashLottie from "assets/campaigns/cc26/splash.lottie";
import { BUCKET_CDN_PREFIX } from "utils/constants";
import { CampaignTheme } from "./types";

// Creator Carnival 2026: 7–23 Oct 2026 IST (activeTo is exclusive).
const CREATOR_CARNIVAL_2026: CampaignTheme = {
  id: "cc26",
  activeFrom: "2026-10-07T00:00:00+05:30",
  activeTo: "2026-10-24T00:00:00+05:30",
  slots: {
    homeHeader: {
      background: "#5F2984",
      appearance: "dark",
    },
    homeHero: {
      imageUrl: `${BUCKET_CDN_PREFIX}cc26/cc26_home_banner.jpg`,
      // 1440x1000 art designed for 360x250 with the 60px header over its top.
      aspectRatio: "360 / 190",
      placeholderColor: "#F9A11B",
      // Header purple at 70% opacity.
      summaryCardBackground: "rgba(95, 41, 132, 0.7)",
    },
    splashIntro: {
      lottieSrc: cc26SplashLottie,
      // One 2s loop at least, then hold (looping) until the app has loaded.
      minDurationMs: 2000,
      maxDurationMs: 8000,
      // Matches the animation's own background so loading never flashes.
      background: "#FCB813",
    },
  },
};

export const CAMPAIGN_THEMES: CampaignTheme[] = [CREATOR_CARNIVAL_2026];
